import { ReactNode } from 'react';

import Logo from '@/v2/components/Logo/Logo';
import Text from '@/v2/components/Typography/Text';
import Colors from '@/v2/constants/Colors';
import emailVerificationConstants from '@/v2/domains/Auth/constants/emailVerificationConstants';

import {
  Wrapper,
  Container,
  Description,
  Actions,
  SecondaryAction,
} from './EmailVerificationCard.styled';

interface EmailVerificationCardProps {
  title: string;
  descriptionLines: ReactNode[];
  children?: ReactNode;
  secondaryAction?: ReactNode;
}

export default function EmailVerificationCard({
  title,
  descriptionLines,
  children,
  secondaryAction,
}: EmailVerificationCardProps) {
  return (
    <>
      <Logo href={emailVerificationConstants.unlinkedLogoHref} />
      <Wrapper>
        <Container>
          <Text variant="title-mid-grey-32" color="black" align="center">
            {title}
          </Text>
          <Description>
            {descriptionLines.map((line, index) => (
              <Text
                key={index}
                variant="dm-16-medium"
                color={Colors.BLACK}
                align="center"
              >
                {line}
              </Text>
            ))}
          </Description>
          <Actions>{children}</Actions>
        </Container>
        {secondaryAction && (
          <SecondaryAction>{secondaryAction}</SecondaryAction>
        )}
      </Wrapper>
    </>
  );
}
